import React from 'react';

const BookingComponentLoadable = React.lazy(() => import('../BookingComponent/Booking/index'));
const BookingTableComponentLoadable = React.lazy(() => import('../BookingComponent/BookingTableNew'));

export {
    BookingComponentLoadable,
    BookingTableComponentLoadable
};
